(() => {
  'use strict';
  if (window.coletteContactLoaded) return;
  window.coletteContactLoaded = true;
  const siteKey = '0x4AAAAAAFB-7lfOiBGUC4Tg';
  let turnstilePromise;
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!turnstilePromise) {
      turnstilePromise = new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('captcha load timeout')), 20000);
        window.coletteTurnstileReady = () => {
          clearTimeout(timeout);
          resolve(window.turnstile);
        };
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=coletteTurnstileReady&render=explicit';
        script.async = true;
        script.onerror = () => { clearTimeout(timeout); reject(new Error('captcha load failed')); };
        document.head.appendChild(script);
      });
    }
    return turnstilePromise;
  }
  function init() {
    document.querySelectorAll('[data-colette-contact]').forEach(async form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const fields = form.querySelector('[data-contact-fields]');
      const button = form.querySelector('[data-contact-submit]');
      const status = form.querySelector('[data-contact-status]');
      let token = '', widget, busy = false, finished = false, payload = null;
      const show = message => { status.textContent = message; };
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || finished) return;
        if (!token) { show('認証が完了するまでお待ちください。'); return; }
        if (!payload && !form.reportValidity()) return;
        payload ??= new URLSearchParams(new FormData(form));
        const sending = new URLSearchParams(payload);
        sending.set('cf-turnstile-response', token);
        busy = true;
        button.disabled = true;
        fields.disabled = true;
        button.textContent = '送信中…';
        show('送信しています。そのままお待ちください。');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 75000);
        try {
          const response = await fetch(form.action, {
            method: 'POST', body: sending, credentials: 'omit',
            mode: 'cors', signal: controller.signal,
          });
          const result = await response.json();
          if (typeof result.message !== 'string') throw new Error('invalid response');
          show(result.message);
          if (response.ok && ['sent', 'accepted', 'uncertain'].includes(result.code)) {
            finished = true;
            button.textContent = result.code === 'uncertain' ? '送信結果の確認が必要です' : '受付済み';
          } else if ([422, 429, 403, 413, 415].includes(response.status)) {
            // SMTP開始前の拒否なので内容を編集できる。
            payload = null;
            fields.disabled = false;
          } else {
            show(result.message + ' 内容を保持しています。再試行ボタンで同じ内容を確認できます。');
          }
        } catch (error) {
          // 配送済みか不明。内容を固定して再試行し、サーバーの重複判定を使う。
          show('通信結果を確認できません。内容を保持しています。認証後に「同じ内容で再試行」を押してください。解決しない場合は online@colette-gift.jp へご連絡ください。');
        } finally {
          clearTimeout(timeout);
          busy = false;
          token = '';
          if (!finished) {
            button.textContent = payload ? '同じ内容で再試行' : '送信する';
            window.turnstile.reset(widget);
          }
        }
      });
      try {
        const api = await loadTurnstile();
        widget = api.render(form.querySelector('[data-contact-turnstile]'), {
          sitekey: siteKey, action: 'contact', language: 'ja', 'response-field': false,
          callback: value => { token = value; button.disabled = busy || finished; },
          'expired-callback': () => { token = ''; button.disabled = true; },
          'error-callback': () => {
            token = ''; button.disabled = true;
            show('認証を読み込めませんでした。改善しない場合は online@colette-gift.jp へご連絡ください。');
          },
        });
      } catch (error) {
        show('認証を読み込めません。ページを再読み込みするか、online@colette-gift.jp へご連絡ください。');
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
